import { useId } from "@fluentui/react-hooks";
import React from "react";
import { Accounts } from "../Refunds";
import { Dropdown, IDropdownOption, PrimaryButton, TeachingBubble } from "@fluentui/react";
import { Link } from "react-router-dom";
import * as Styles from "../styles/DropdownAccountsStyles";
import { RefundIbanRequiredMessage } from "../refundLimits";

export interface AccountProps
{
    accounts: Accounts[],
    errorMessage: string,
    alignment?: string,
    paddingTop?: string,
    dropdownChange: (item: string) => void;
    disabled?: boolean;
    selectedIban?: string;
}

export const DropdownAccounts = (props: AccountProps) =>
{
    const dropdownId = useId();
    const [uncontrolledKey, setUncontrolledKey] = React.useState<string | number | undefined>(undefined);
    const [options, setOptions] = React.useState<IDropdownOption[]>([]);
    const [tooltipVisibility, setTooltipVisibility] = React.useState<boolean>(false);
    const alignment = props.alignment !== undefined ? props.alignment : "center";
    const isControlled = props.selectedIban !== undefined;

    React.useEffect(() =>
    {
        const dropdownOptions: IDropdownOption[] = props.accounts.map((account) =>
        ({
            key: account.id,
            text: account.value,
        }));
        setOptions(dropdownOptions);

        if(!isControlled)
        {
            const defaultOption = props.accounts.find((account) => account.default);
            setUncontrolledKey(defaultOption?.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.accounts, isControlled]);

    const controlledKey = props.accounts.find((account) => account.value === props.selectedIban)?.id;
    const selectedKey = isControlled ? controlledKey : uncontrolledKey;
    const hasOptions = options.length > 0;
    // Sin cuentas no hay key ni selección: el desplegable va vacío y deshabilitado.
    // Con cuentas se respeta props.disabled (un || true lo ignoraría).
    const isDropdownDisabled = hasOptions ? props.disabled === true : true;

    const onChange = (_event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption): void =>
    {
        if(!isControlled)
        {
            setUncontrolledKey(option ? option.key : undefined);
        }
        props.dropdownChange(option?.text ?? "");
    };
    const handleMouseEnter = () =>
    {
        setTooltipVisibility(true);
    };
    const handleMouseLeave = () =>
    {
        setTooltipVisibility(false);
    };

    return(
        <React.Fragment>
            <Styles.Row>
                <Styles.ColDropdown>
                    <Dropdown id={dropdownId}
                        selectedKey={hasOptions ? selectedKey : undefined}
                        placeholder={RefundIbanRequiredMessage}
                        label="IBAN Cuenta Bancaria"
                        options={options}
                        styles={Styles.dropdownStyles}
                        onChange={hasOptions ? onChange : undefined}
                        required={hasOptions}
                        errorMessage={props.errorMessage}
                        disabled={isDropdownDisabled}
                    />
                </Styles.ColDropdown>
                <Styles.ColButton alignment={alignment} paddingTop={props.paddingTop}>
                    <Link to={{pathname: "/profile/bank-accounts"}} id={`DropdownBubble-${dropdownId}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                        <PrimaryButton>
                            Cuentas Corrientes
                        </PrimaryButton>
                    </Link>
                </Styles.ColButton>
            </Styles.Row>
            {tooltipVisibility &&
            (
                <TeachingBubble target={`#DropdownBubble-${dropdownId}`} onDismiss={handleMouseLeave} headline="Cuentas Corrientes">
                    Para cumplir con la normativa antibloqueo de capitales y financiación del terrorismo sólo puedes realizar
                    reembolsos a cuentas corrientes en las que hayas demostrado tu titularidad.
                    <br />
                    <br />
                    Este botón te permite navegar a la sección de las Cuentas Corrientes.
                </TeachingBubble>
            )}
        </React.Fragment>
    );
};

export default DropdownAccounts;